import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast, Toaster } from "sonner";
import { ArrowLeft, Mail } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BG = "https://images.unsplash.com/photo-1552664730-d307ca884978?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success("Cek inbox email Anda");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Gagal mengirim email");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen relative overflow-hidden bg-[#151A18]">
      <div className="absolute inset-0">
        <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover"
             style={{ filter: "blur(6px) saturate(1.05)", transform: "scale(1.05)" }}/>
        <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, rgba(21,26,24,0.72) 0%, rgba(45,71,57,0.60) 60%, rgba(21,26,24,0.85) 100%)" }}/>
      </div>

      <div className="relative z-10 min-h-screen flex items-center justify-center p-6">
        <div className="w-full max-w-sm rounded-2xl p-8 sm:p-10 backdrop-blur-2xl bg-white/10 border border-white/20 shadow-[0_20px_80px_-20px_rgba(0,0,0,0.6)]">
          <Link to="/login" className="inline-flex items-center gap-2 text-xs text-white/60 hover:text-white mb-6"><ArrowLeft size={14}/> Kembali ke login</Link>
          <div className="flex items-center gap-2 mb-6">
            <div className="w-9 h-9 bg-[#D99C3B] flex items-center justify-center font-display font-bold text-[#151A18] rounded-sm">A</div>
            <div className="font-display text-lg text-white">Adika Cipta Kreasindo</div>
          </div>

          {!sent ? (
            <form onSubmit={submit} data-testid="forgot-form">
              <div className="mb-6">
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/60 mb-2">Reset Password</div>
                <h2 className="font-display text-3xl text-white tracking-tight">Lupa password?</h2>
                <p className="text-sm text-white/60 mt-2">Kami akan kirim link reset ke email terdaftar Anda.</p>
              </div>
              <div>
                <Label className="text-[10px] uppercase tracking-[0.2em] text-white/70">Email</Label>
                <Input data-testid="forgot-email" value={email} onChange={e=>setEmail(e.target.value)} required type="email" placeholder="anda@perusahaan.com"
                       className="mt-1.5 rounded-lg h-11 bg-white/5 border-white/20 text-white placeholder:text-white/40 focus-visible:ring-2 focus-visible:ring-[#D99C3B]"/>
              </div>
              <Button disabled={busy} data-testid="forgot-submit"
                      className="w-full mt-6 h-12 rounded-lg bg-[#D99C3B] hover:bg-[#c48a2f] text-[#151A18] font-medium shadow-lg shadow-[#D99C3B]/20">
                {busy ? "Mengirim…" : "Kirim Link Reset"}
              </Button>
            </form>
          ) : (
            <div className="text-center py-4" data-testid="forgot-sent">
              <div className="w-14 h-14 rounded-full bg-[#D99C3B]/20 flex items-center justify-center mx-auto mb-4">
                <Mail size={24} className="text-[#D99C3B]"/>
              </div>
              <h2 className="font-display text-2xl text-white mb-2">Email terkirim</h2>
              <p className="text-sm text-white/70 max-w-xs mx-auto">Bila <span className="text-[#D99C3B]">{email}</span> terdaftar, Anda akan menerima link reset password dalam 1-2 menit. Link berlaku 1 jam.</p>
              <p className="text-xs text-white/40 mt-4">Belum menerima? Cek folder Spam atau <button onClick={()=>setSent(false)} className="underline hover:text-white">coba email lain</button>.</p>
            </div>
          )}
        </div>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
